import { makeHttpRequest } from "@/shared";

import { mapCalculatedRepairFromServer } from "./mappers/mapCalculatedRepairFromServer";
export const removeRepairDiscount = async (sessionKey, temporaryKey) => {
    const response = (
        await makeHttpRequest({
            url: `/repair/builder/${sessionKey}/remove/discount`,
            method: "DELETE",
            params: {
                temporary_key: temporaryKey,
            },
        })
    ).data;

    return mapCalculatedRepairFromServer(response.data);
};
